/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC44NiAxSDguNDNINy40M0gxVjEuMDdIMC45MzAwMDhWNy41VjguNVYxNC45M0gxVjE1SDcuNDNIOC40M0gxNC44NlYxNC45M0gxNC45M0wxNC45MyA4LjVWNy41VjEuMDdIMTQuODZWMVpNMS45MzAwMSAxNEg3LjQzSDguNDNIMTMuOTNMMTMuOTMgOC41VjcuNVYySDguNDNINy40M0gxLjkzMDAxTDEuOTMwMDEgNy41TDEuOTMwMDEgOC41TDEuOTMwMDEgMTRaIiBmaWxsPSJpbmhlcml0Ii8+";